import { MortgageCalculator } from "../utils/calculators/mortgage-calculator";
import { StampDutyCalculator } from "../utils/calculators/stamp-duty-calculator";
import { BuyToLetCalculator } from "../utils/calculators/buy-to-let-calculator";

class PropertyCalculator{
    mortgageCalculator = new MortgageCalculator();
    stampDutyCalculator = new StampDutyCalculator();
    buyToLetCalculator = new BuyToLetCalculator()

    constructor() {
        const parent = document.querySelector(".property-calculator-choices");

        if (!parent) {
            return;
        }

        [...parent.children].forEach(x => {
            x.addEventListener("click", (ev) => {
                ev.preventDefault();
                const el = ev.target;
                const toggle = el.getAttribute("data-toggle")
                const target = document.querySelector(`[data-calc='${toggle}']`)

                const allToDisable = [...document.querySelectorAll("[data-calc]")].filter(x => x !== target)

                for (const toDisable of allToDisable) {
                    toDisable.classList.remove("active")
                }

                target.classList.toggle("active");
            })
        })
    }
}

window.propertyCalculator = new PropertyCalculator();